import { render, staticRenderFns } from "./DialogCollectDataConfirmService.vue?vue&type=template&id=38fdf9df&scoped=true"
import script from "./DialogCollectDataConfirmService.vue?vue&type=script&lang=js"
export * from "./DialogCollectDataConfirmService.vue?vue&type=script&lang=js"
import style0 from "./css/common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DialogCollectDataConfirmService.vue?vue&type=style&index=1&id=38fdf9df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdf9df",
  null
  
)

export default component.exports